










































































import { Component, Vue } from "vue-property-decorator";
import {
  NavBar,
  Image,
  Tabbar,
  TabbarItem,
  Search,
  Field,
  Picker,
  Popup,
  Button,
  Toast,
  List,
  Cell,
  CellGroup,
  Dialog,
  Tag,
  Icon,
  Row,
  Col,
  NoticeBar,
  Loading,
  Card,
  Tab,
  Tabs,
} from "vant";
import api from "../../../components/http/api";
import { XjqyNuminfo } from "./XjqyApi";

declare const $: any;

@Component({
  components: {
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Card.name]: Card,
    [Search.name]: Search,
    [Field.name]: Field,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [List.name]: List,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [NoticeBar.name]: NoticeBar,
    [Loading.name]: Loading,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
})
export default class XjqyHome extends Vue {
  private cusLvImg: string = "";
  private cuslv: string = "";
  private sydtabactive: number = 0;
  private xjqynuminfo: XjqyNuminfo = {} as XjqyNuminfo;

  private djbuttonactive: string = "0";

  protected created() {
    this.getCustomerLevel();
  }

  protected getCustomerLevel() {
    api.get("/weixinmp/xsyx/myuser/getCustomerLevel").then((res: any) => {
      if (res.data.level === "游客") {
        this.cusLvImg = require("@/assets/image/kh-vimg/yk.svg");
        this.cuslv = "0";
      } else if (res.data.level === "V") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v.svg");
        this.cuslv = "0";
      } else if (res.data.level === "V0") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v0.svg");
        this.cuslv = "0";
      } else if (res.data.level === "V0+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v0plus.svg");
        this.cuslv = "0";
      } else if (res.data.level === "V1") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v1.svg");
        this.cuslv = "1";
      } else if (res.data.level === "V1+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v1plus.svg");
        this.cuslv = "1";
      } else if (res.data.level === "V2") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v2.svg");
        this.cuslv = "2";
      } else if (res.data.level === "V2+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v2plus.svg");
        this.cuslv = "2";
      } else if (res.data.level === "V3") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v3.svg");
        this.cuslv = "3";
      } else if (res.data.level === "V3+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v3plus.svg");
        this.cuslv = "3";
      } else if (res.data.level === "V4") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v4.svg");
        this.cuslv = "3";
      } else if (res.data.level === "V4+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v4plus.svg");
        this.cuslv = "3";
      } else if (res.data.level === "V5") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v5.svg");
        this.cuslv = "3";
      } else if (res.data.level === "V5+") {
        this.cusLvImg = require("@/assets/image/kh-vimg/v5plus.svg");
        this.cuslv = "3";
      }

      api.get("/weixinmp/xsyx/myuser/getXjqyNuminfo").then((res1: any) => {
        this.xjqynuminfo = res1.data;
        if (this.cuslv === "1") {
          if (this.xjqynuminfo.v1num > 0) {
            this.djbuttonactive = "1";
          }
        } else if (this.cuslv === "2") {
          if (this.xjqynuminfo.v2num > 0) {
            this.djbuttonactive = "2";
          } else if (this.xjqynuminfo.v1num > 0) {
            this.djbuttonactive = "1";
          }
        } else if (this.cuslv === "3") {
          if (this.xjqynuminfo.v3upnum > 0) {
            this.djbuttonactive = "3";
          } else if (this.xjqynuminfo.v2num > 0) {
            this.djbuttonactive = "2";
          } else if (this.xjqynuminfo.v1num > 0) {
            this.djbuttonactive = "1";
          }
        }
      });
    });
  }

  protected toAwardingDetail(activityid: any) {
    api.get("/weixinmp/xsyx/myuser/getXjqyNuminfo").then((res: any) => {
      this.xjqynuminfo = res.data;
      if (activityid === "1") {
        if (this.xjqynuminfo.v1num > 0) {
          this.$router.push("/main/xjqy/xjqyAwardingDetail/" + activityid);
        } else {
          this.$toast({
            message: "8元代金券余额不足，请刷新后重试",
            position: "bottom",
          });
        }
      } else if (activityid === "2") {
        if (this.xjqynuminfo.v2num > 0) {
          this.$router.push("/main/xjqy/xjqyAwardingDetail/" + activityid);
        } else {
          this.$toast({
            message: "10元代金券余额不足，请刷新后重试",
            position: "bottom",
          });
        }
      } else if (activityid === "3") {
        if (this.xjqynuminfo.v3upnum > 0) {
          this.$router.push("/main/xjqy/xjqyAwardingDetail/" + activityid);
        } else {
          this.$toast({
            message: "20元代金券余额不足，请刷新后重试",
            position: "bottom",
          });
        }
      }
    });
  }
}
